
<style lang="less" scoped>
.container {
  background: rgba(247, 247, 247, 1);
  padding: 16px;
  width: 718px;
  height: 100vh;
  .evaluate-content {
    background: #fff;
    width: 670px;
    box-shadow: 0px 0px 8px 0px rgba(219, 219, 219, 0.5);
    border-radius: 6px;
    padding: 24px;
    .evaluate-title {
      text-align: left;
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(35, 44, 55, 1);
      line-height: 44px;
    }
    .img-box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      margin-bottom: 40px;
      .evaluate-star-style {
        width: 56px;
        height: 52px;
        margin-right: 28px;
      }
    }
    .evaluate-textarea {
      width: 622px;
      background:#F7F7F7;
      border-radius: 6px;
      border: 1px solid #EFEFEF;
      // border: none;
      padding: 24px;
      margin-top: 47px;
    }

    .evaluate-textarea::-webkit-input-placeholder {
      /* WebKit browsers */
      color:#BDC3CE;
      font-size:26px;
    }
    .evaluate-textarea:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color:#BDC3CE;
      font-size:26px;
    }
    .evaluate-textarea::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color:#BDC3CE;
      font-size:26px;
    }
    .evaluate-textarea::-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color:#BDC3CE;
      font-size:26px;
    }
    .comment {
      height: 36px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: 36px;
      text-align: center;
    }
    .grade1,
    .grade2 {
      color: rgba(137, 147, 159, 1);
    }
    .grade3,
    .grade4 {
      color: rgba(245, 166, 35, 1);
    }
    .grade5 {
      color: rgba(245, 103, 11, 1);
    }
  }
  .submit-box {
    .submit-btn {
      width: 602px;
      height: 100px;
      line-height: 100px;
      background: rgba(189, 195, 206, 1);
      border-radius: 10px;
      color: #fff;
      margin-top: 50px;
      border: none;
      font-size: 32px;
    }
    .blue-btn {
      width: 602px;
      height: 100px;
      line-height: 100px;
      border-radius: 10px;
      margin-top: 50px;
      border: none;
      background: rgba(65, 105, 225, 1);
      color: #fff;
      font-size: 32px;
    }
  }
  .contact-us-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    .contact-us-img {
      width: 28px;
      height: 26px;
      margin-right: 6px;
    }
    .contact-us-text {
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      line-height: 36px;
      margin-right: 18px;
    }
    .phone-number {
      color: #4169e1;
    }
  }
  .evaluate-info {
    // width: 640px;
    // display: flex;
    // // justify-content: center;
    // align-items: center;
    // box-lines:single;
    // flex-wrap: wrap;
    margin: 32px 15px 47px;
    .evaluate-info-text {
      float: left;
      width: 285px;
      height: 60px;
      border-radius: 6px;
      border: 2px solid rgba(189, 195, 206, 1);
      margin: 15px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: 60px;
      color: rgba(137, 147, 159, 1);
      text-align: center;
    }
    .selected {
      background: rgba(243, 247, 251, 1);
      border: 2px solid rgba(65, 105, 225, 1);
      color: rgba(65, 105, 225, 1);
    }
  }
  .hfq-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
<template>
  <div class="container">
    <div class="evaluate-content">
      <div class="evaluate-title">总体评价</div>
      <div class="img-box">
        <img
          class="evaluate-star-style"
          @click="setEvaluate(1,1)"
          :src="starCount==0?starEmpty:starCount==1||starCount==2?starGray:starCount==3||starCount==4?starYellow:starRed"
        />
        <img
          class="evaluate-star-style"
          @click="setEvaluate(1,2)"
          :src="starCount==0||starCount==1?starEmpty:starCount==2?starGray:starCount==3||starCount==4?starYellow:starRed"
        />
        <img
          class="evaluate-star-style"
          @click="setEvaluate(1,3)"
          :src="starCount==0||starCount==1||starCount==2?starEmpty:starCount==3||starCount==4?starYellow:starRed"
        />
        <img
          class="evaluate-star-style"
          @click="setEvaluate(1,4)"
          :src="starCount==0||starCount==1||starCount==2||starCount==3?starEmpty:starCount==4?starYellow:starRed"
        />
        <img
          class="evaluate-star-style"
          @click="setEvaluate(5,5)"
          :src="starCount==0||starCount==1||starCount==2||starCount==3||starCount==4?starEmpty:starRed"
        />
      </div>
      <div class="comment grade1" v-if="starCount==1">非常差</div>
      <div class="comment grade2" v-if="starCount==2">差</div>
      <div class="comment grade3" v-if="starCount==3">一般</div>
      <div class="comment grade4" v-if="starCount==4">满意</div>
      <div class="comment grade5" v-if="starCount==5">超赞</div>
      <div class="evaluate-info" v-if="starCount!=0">
        <div
          v-for="(item,index) in evaluationList"
          :class="[selectArr.includes(index)?'evaluate-info-text hfq-ellipsis selected':'evaluate-info-text hfq-ellipsis']"
          @click="selectEvaluate(index)"
          :key="index"
        >{{item.name}}</div>
      </div>
      <textarea
        class="evaluate-textarea"
        placeholder="请留下您的宝贵意见，我们将竭力为您服务"
        rows="5"
        v-model="evaluateContent"
      />
    </div>
    <div class="submit-box">
      <button :class="[starCount==0||evaluateContent.length==0 ? 'submit-btn' : 'blue-btn']" @click="submitComplain" :disabled='evaluateContent.length==0'>提交</button>
    </div>
    <div class="contact-us-box">
      <img class="contact-us-img" src="../../assets/img/phone.png" />
      <div class="contact-us-text">联系我们</div>
      <div class="contact-us-text phone-number"><a href="tel:4000-185-581">4000-185-581</a></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: "Complaints",
  components: {
    Toast
  },
  data() {
    return {
      starCount: 0,
      starEmpty: require("../../assets/img/star_empty.png"),
      starGray: require("../../assets/img/star_gray.png"),
      starYellow: require("../../assets/img/star_yellow.png"),
      starRed: require("../../assets/img/star_red.png"),
      evaluationList: [],
      selectEvaluateIndexList: [],
      evaluateContent: "",
      cityId: "",
      isSelect:-1,
      selectArr:[]
    };
  },
  created () {
    this.cityId = this.$route.query.cityId;
  },
  methods: {
    // 提交吐槽
    submitComplain() {
      // var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      // let content = this.evaluateContent.replace(regStr, '');
      // let content = encodeURIComponent(encodeURIComponent(this.evaluateContent))
      if (this.starCount != 0) {
        let evaluationList = this.evaluationList;
        let evaluateOpinion = [];
        for (let i = 0; i < this.selectArr.length; i++) {
          evaluateOpinion.push(evaluationList[this.selectArr[i]].name);
        }
        let param = {
          cityId: this.cityId,
          evaluate: this.starCount,
          evaluateContent: evaluateOpinion.join(","),
          evaluateOpinion: this.evaluateContent
        };
        this.$axios
        .post("api/xz/evaluate/save/",param)
          .then(res => {
            if (res.success) {
              Toast('保存成功！');
              this.starCount = 0;
              this.evaluateContent='';
              this.selectArr = [];
              // wx.navigateBack();
              setTimeout(()=>{
                this.isMiniProgram(res => {
                  if (res) {
                    wx.miniProgram.navigateBack();
                  } else {
                    // this.$router.go(-1);       
                    this.$router.push('/');          
                  }
                });
              },500)
            } else {
              Toast(res.status.description);
            }
          })
          .catch(err => {
            Toast(res.description);
          });
      } else {
        Toast('请选择评星！');
      }
    },
    callPhone() {
      wx.makePhoneCall({
        phoneNumber: "4000-185-581"
      });
    },
    setEvaluate(level,num) {
      this.getConfigList(level, num);
    },
    selectEvaluate(e) {
      if (this.selectArr.indexOf(e)>-1) {
        this.selectArr.splice(this.selectArr.indexOf(e),1)
      }else{
        this.selectArr.push(e)
      }
    },
    getConfigList(group,num) {
      this.$axios
        .post('api/xz/evaluate/config/',{
          group:group,
          cityId: this.cityId
        }).then(res=>{
          if (res.success) {
            let list = res.result;
            let len = list.length;
            this.starCount = num
            this.evaluationList = list
          }
        }).catch(err=>{
          Toast(res.message);
        })
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/make_complaints/index.vue